<style scoped>
svg {
  margin-right: 5%;
}

v-item--active {
  color: black;
}

.form-info {
  font-size: small;
}

.myBtnTextColor {
  color: white;
}
</style>
<template class="ma-0 pa-0">
  <v-container fluid class="ma-0 pa-0" v-if="isCategoriesRetrievied">
    <v-card class="ma-0 ma-md-2 pa-0 pa-md-2" elevation="10">
      <v-card-title class="form-info">
        <h4 class="text-left"> {{
            `${formTitle} `
          }}
        </h4>
        &nbsp;<br/>
        <div class="font-weight-regular font-italic form-info">
          <template v-if="this.editedIndex != -1 && editedItem.properties.datecreated != null">
            créée {{ editedItem.properties.datecreated | dateIso2Fr }} par
            {{ editedItem.properties.creator_name }}<br/>
          </template>
          <template v-if="this.editedIndex != -1 && editedItem.properties.isvalidated">
            <span class="font-weight-regular font-italic form-info">
              validée le {{ editedItem.properties.datevalidation | dateIso2Fr }} par
              {{ editedItem.properties.validator_name }}</span
            >
            <!--<v-switch v-model="editedItem.properties.isvalidated"
                      label="Dégradation Validée ?"/>-->
          </template>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row class="text-center ma-0 pa-0">
            <v-col cols="12" class="ma-0 pa-0">
              <template v-if="!dialogFormObjetReadOnlyMode">
                <v-btn-toggle v-model="editedItem.properties.idcategorie" @change="categoryChanged">
                  <v-layout row wrap>
                    <template v-if="idUserGroup===12 || idUserGroup===13">
                      <!--- DEBUT cas de la POLICE Group 12 ou SPADOM 13 seul categorie tags-->
                      <v-flex xs6 sm6 md6 lg4 class="py-1">
                        <v-btn
                          class="ma-0"
                          :value="1"
                          :width="`${btnWidth}px`"
                          :height="`${iconHeight + 8}px`"
                          v-bind="buttonSize"
                          :color="buttonColor(editedItem.properties.idcategorie, 1, 'TAG')"
                          :elevation="editedItem.properties.idcategorie == 1 ? 0 : 12"
                          :depressed="editedItem.properties.idcategorie == 1 ? true : false"
                          v-bind:disabled="true"
                        >
                          <!-- if button outline then use this in icon
                        :fill_color="$vuetify.theme.themes.light.secondary"
                        -->
                          <!--<my-svg-icon :width="`${iconHeight}px`" :height="`${iconHeight}px`"-->
                          <my-svg-icon
                            :width="iconHeight"
                            :height="iconHeight"
                            :stroke_color="getCategoryStroke_color(1)"
                            :fill_color="'#FFF'"
                            :stroke_width="getCategoryStroke_width(1)"
                            :path_geometry="getCategoryPath_geometry(1)"
                          />
                          <div class="mb-0 myBtnTextColor">{{ getCategoryName(1) }}</div>
                        </v-btn>
                      </v-flex>
                      <!--- FIN cas de la POLICE Groupe 12 seulement les tags comme categorie -->
                    </template>
                    <template v-else>
                      <template v-for="c in categories">
                        <template v-if="c.id < 1000">
                          <v-flex v-bind:key="c.id" xs6 sm6 md6 lg4 class="py-1">
                            <v-btn
                              v-bind:key="c.id"
                              class="ma-0"
                              :value="c.id"
                              :width="`${btnWidth}px`"
                              :height="`${iconHeight + 8}px`"
                              v-bind="buttonSize"
                              :color="buttonColor(editedItem.properties.idcategorie, c.id, c.name)"
                              :elevation="editedItem.properties.idcategorie == c.id ? 0 : 12"
                              :depressed="editedItem.properties.idcategorie == c.id ? true : false"
                              v-bind:disabled="dialogFormObjetReadOnlyMode"
                            >
                              <!-- if button outline then use this in icon
                            :fill_color="$vuetify.theme.themes.light.secondary"
                            -->
                         <!--<my-svg-icon :width="`${iconHeight}px`" :height="`${iconHeight}px`"-->
                              <my-svg-icon
                                :width="iconHeight"
                                :height="iconHeight"
                                :stroke_color="c.stroke_color"
                                :fill_color="c.fill_color"
                                :stroke_width="c.stroke_width"
                                :path_geometry="c.path_geometry"
                              />
                              <div class="mb-0 myBtnTextColor">{{ c.name }}</div>
                            </v-btn>
                          </v-flex>
                        </template>
                      </template>
                    </template>
                  </v-layout>
                </v-btn-toggle>
                <template v-if="editedItem.properties.idcategorie == 1">
                  <!-- isUrgent -->
                  <v-col cols="12" class="ma-0 pa-0">
                    <v-layout row align-baseline align-start>
                      <v-flex xs8>
                        <v-subheader class="subtitle-1 font-weight-medium align-start">
                          A traiter en priorité ?
                        </v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-switch v-model="editedItem.properties.isurgent"
                                  :label="`${editedItem.properties.isurgent ? 'OUI': 'NON'}`">
                        </v-switch>
                      </v-flex>
                    </v-layout>
                  </v-col>
                </template>
              </template>
              <template v-if="dialogFormObjetReadOnlyMode">
                <v-btn
                  class="ma-0"
                  :value="editedItem.properties.idcategorie"
                  :width="`${btnWidth}px`"
                  :height="`${iconHeight + 8}px`"
                  v-bind="buttonSize"
                  color="accent"
                  :elevation="0"
                  :depressed="true"
                  v-bind:disabled="dialogFormObjetReadOnlyMode"
                >
                  <!-- if button outline then use this in icon
                  :fill_color="$vuetify.theme.themes.light.secondary"
                  -->
                  <my-svg-icon
                    :width="iconHeight"
                    :height="iconHeight"
                    :stroke_color="getCategoryStroke_color(editedItem.properties.idcategorie)"
                    fill_color="black"
                    :stroke_width="getCategoryStroke_width(editedItem.properties.idcategorie)"
                    :path_geometry="getCategoryPath_geometry(editedItem.properties.idcategorie)"
                  />
                  <div class="mb-0">{{ getCategoryName(editedItem.properties.idcategorie) }}</div>
                </v-btn>
              </template>
            </v-col>
            <!-- titre -->
            <v-col cols="12" class="ma-1 pa-2">
              <!--<v-text-field v-model="editedItem.name" label="Name"/>-->
              <h4 class="text-left"> {{
                  editedItem.properties.title
                }}
              </h4>
              <!-- on enleve le textfield suite demande utilisateurs du 23 juillet 2020
              <v-text-field
                ref="titre"
                v-model="editedItem.properties.title"
                required
                :counter="maxTextLength"
                :rules="[
                  () => !!editedItem.properties.title || 'Ce champ est obligatoire',
                  () => editedItem.properties.title.length <= maxTextLength || '255 caractères max'
                ]"
                :error-messages="errorMessages"
                v-bind:readonly="dialogFormObjetReadOnlyMode"
                v-bind:disabled="dialogFormObjetReadOnlyMode"
                v-bind:clearable="!dialogFormObjetReadOnlyMode"
                label="Titre"
              />-->
            </v-col>
            <!-- commentaire -->
            <!--<template v-if="!(dialogFormObjetReadOnlyMode &&
             (!editedItem.properties.comment))">-->
            <v-col cols="12" class="ma-1 pa-2">
              <template v-if="dialogFormObjetReadOnlyMode">
                <p class="text-left"> {{
                    editedItem.properties.comment
                  }}
                </p>
              </template>
              <template v-else>
                <v-textarea dense
                            ref="commentaire"
                            rows="3"
                            v-model="editedItem.properties.comment"
                            v-bind:readonly="dialogFormObjetReadOnlyMode"
                            v-bind:disabled="dialogFormObjetReadOnlyMode"
                            v-bind:clearable="!dialogFormObjetReadOnlyMode"
                            prepend-inner-icon="comment"
                            label="Commentaire"
                />
              </template>
            </v-col>
            <template v-if="pictures.length > 0">
              <template v-for="p in pictures">
                <v-col v-bind:key="p.id" cols="12" lg="6">
                  <v-img v-bind:key="p.id" :src="p.url"/>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="ma-0 pa-0">
        <template v-if="dialogFormObjetReadOnlyMode && checkEditPermissions(editedItem)">
          <v-btn color="blue darken-1" text @click="toggleEditMode">Editer</v-btn>
        </template>
        <v-btn color="blue darken-1" text @click="cancel">
          {{ dialogFormObjetReadOnlyMode ? "Fermer" : "Annuler" }}
        </v-btn>
        <v-spacer></v-spacer>
        <template v-if="!dialogFormObjetReadOnlyMode">
          <v-btn color="blue darken-1" text @click="save">Sauver</v-btn>
        </template>
        <template v-if="isGoluxAccessible
        && dialogFormObjetReadOnlyMode && editedItem.properties.idaffairegoeland!=null">
          <a
            :href="`https://golux.lausanne.ch/goeland/affaire2/affaire_data.php?idaffaire=${editedItem.properties.idaffairegoeland}`"
            target="_blank">Affaire Goéland : {{ editedItem.properties.idaffairegoeland }}</a>
        </template>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { isNullOrUndefined } from 'cgil-html-utils';
import {
  APP, DEV, DEFAULT_BASE_SERVER_URL, getLog,
} from '../config';
import DegradationMixin from './Degradation_mixin';
import MySvgIcon from './MySvgIcon.vue';
import degradation from './Degradation';
import degradationCategories from './DegradationCategories';
import {
  getUserId, getUserIsAdmin, getUserIsValidator, getIsGoluxAccessible,
  isUserHavingLimitedCategories, getUserFirstLimitedCategory, getUserIdGroup,
} from './Login';

const MODULE_NAME = 'DegradationForm';
const log = getLog(MODULE_NAME, 4, 2);
export default {
  name: 'DegradationForm',
  components: { MySvgIcon },
  mixins: [DegradationMixin],
  props: {
    currentObject: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    appName: APP,
    isInDev: DEV,
    isUserAdmin: false,
    isUserValidator: false,
    idUser: null,
    idUserGroup: null,
    isGoluxAccessible: getIsGoluxAccessible(),
    validLoginForm: false,
    categories: [],
    isCategoriesRetrievied: false,
    pictures: [],
    isListItemsRetrieved: false,
    maxTextLength: 255,
    dialogFormObjetReadOnlyMode: false,
    dialogFormObjetHasErrors: false,
    errorMessages: '',
  }),
  created() {
    log.t(`# ${MODULE_NAME} created()`);
  },
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
    degradationCategories.getCategorieList((data, errMessage) => {
      if (!isNullOrUndefined(data)) {
        this.categories = data;
        log.l('# IN degradationCategories -> categories :', this.categories);
        this.isCategoriesRetrievied = true;
      } else {
        log.e(
          `# GOT ERROR IN initialize() in callback for degradationCategories.degradationCategories data: ${errMessage}`,
        );
        this.isCategoriesRetrievied = false;
      }
    });
    this.isUserAdmin = getUserIsAdmin();
    this.isUserValidator = getUserIsValidator();
    this.idUser = getUserId();
    this.idUserGroup = getUserIdGroup(); // si idUserGroup = 12,13 on est dans le cas POLICE,SPADOM
    this.editedItem = { ...this.currentObject };
    if (this.idUserGroup === 12 || this.idUserGroup === 13) { // POLICE OU SPADOM
      this.editedItem.properties.idcategorie = 1; // si on est avec police c'est que du tag
      this.editedItem.properties.categorie = 'Tags';
      this.categoryChanged();
    }
    this.dialogFormObjetReadOnlyMode = this.readOnly;
    this.updateEditedIndex();
  }, // end of mounted
  filters: {
    dateIso2Fr(strIsoDate) {
      // log.t('dateIso2Fr strIsoDate :', strIsoDate);
      if (isNullOrUndefined(strIsoDate)) {
        return '';
      }
      let y = null;
      let m = null;
      let d = null;
      [y, m, d] = strIsoDate.split('T')[0].split('-');
      return `${[d, m, y].join('-')} à ${strIsoDate.split('T')[1].split('.')[0]}`;
    },
  },
  computed: {
    formValidation() {
      return {
        titre: this.editedItem.properties.title,
      };
    },
    formTitle() {
      if (this.editedIndex === -1) {
        return `Nouvelle ${this.subject} : `;
      }
      return `${this.subject} (id:${this.editedItem.properties.id}), `;
    },
    iconHeight() {
      // https://vuetifyjs.com/en/customization/breakpoints/
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 20;
        case 'sm':
          return 26;
        case 'md':
          return 32;
        case 'lg':
          return 40;
        case 'xl':
          return 60;
        default:
          return 40;
      }
    },
    btnWidth() {
      // https://vuetifyjs.com/en/customization/breakpoints/
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 134;
        case 'sm':
          return 166;
        case 'md':
          return 182;
        case 'lg':
          return 182;
        case 'xl':
          return 242;
        default:
          return 182;
      }
    },
    buttonSize() {
      const size = {
        xs: 'x-small',
        sm: 'small',
        md: 'small',
        lg: 'small',
        xl: 'large',
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
  },

  watch: {
    currentObject(newVal, oldVal) {
      log.t(`in watch currentObject(${newVal}, ${oldVal})`, newVal, oldVal);
      // this.editedItem = JSON.parse(JSON.stringify(newVal));
      // pas de copie a ce stade pour qu'un update de position fonctionne
      this.editedItem = newVal;
      this.pictures = [];
      log.w(
        `-id:${this.editedItem.properties.id}, Edit Allowed : ${this.checkEditPermissions(
          this.editedItem,
        )}`,
      );
      if (this.idUserGroup === 12 || this.idUserGroup === 13) { // 12 POLICE 13 SPADOM
        this.editedItem.properties.idcategorie = 1; // si groupe  police, spadom c'est que du tag
        this.editedItem.properties.categorie = 'Tags';
        this.categoryChanged();
      }
      this.dialogFormObjetReadOnlyMode = !this.checkEditPermissions(this.editedItem);
      this.updateEditedIndex();
    },
    readOnly(newVal, oldVal) {
      log.t(`in watch readOnly(new:${newVal}, old:${oldVal})`);
      this.dialogFormObjetReadOnlyMode = this.readOnly;
      log.w(
        `-id:${this.editedItem.properties.id}, Edit Allowed : ${this.checkEditPermissions(
          this.editedItem,
        )}`,
      );
      this.dialogFormObjetReadOnlyMode = !this.checkEditPermissions(this.editedItem);
    },
  },

  methods: {
    toggleEditMode() {
      if (this.checkEditPermissions(this.editedItem)) {
        this.dialogFormObjetReadOnlyMode = false;
      }
    },
    checkEditPermissions(item) {
      if (item.properties.id === 0) {
        return true; // cas d'un nouvel enregistrement
      }
      if (isUserHavingLimitedCategories()) {
        // SI OBJET CID ET QUE USER CID ON MONTRE UNIQUEMENT CAR PAS EDITION
        if (item.properties.idcategorie === getUserFirstLimitedCategory()) {
          return false;
        }
      }
      if (item.properties.isvalidated === null) {
        if (this.idUser === item.properties.creator || this.isUserAdmin || this.isUserValidator) {
          return true;
        }
      }
      return false;
    },
    updateEditedIndex() {
      if (!isNullOrUndefined(this.editedItem.properties)) {
        if (this.editedItem.properties.id === 0) {
          this.editedIndex = -1; // cas d'un nouvel element
        } else {
          this.editedIndex = this.editedItem.properties.id;
          // on est dans le cas de l'édition d'une degradation
          this.getListPictures(this.editedItem.properties.id);
        }
      } else {
        this.editedIndex = -1; // cas d'un nouvel element
      }
    },
    getListPictures(idDegradation) {
      log.t(`# in getListPictures(${idDegradation})`);
      degradation.getListPictures(idDegradation, (data, errMessage) => {
        if (!isNullOrUndefined(data)) {
          this.pictures = data;
          if (this.pictures.length > 0) {
            this.pictures = this.pictures.map((p) => {
              const pic = { ...p };
              pic.url = `${DEFAULT_BASE_SERVER_URL}${p.url}`;
              return pic;
            });
          }
          log.l('# IN initialize -> objet data :', this.pictures);
        } else {
          log.e(
            `# GOT ERROR IN initialize() in callback for degradation.getList data: ${errMessage}`,
          );
          this.pictures = [];
        }
      });
    },
    cancel() {
      log.t('# in cancel');
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedIndex = -1;
      this.pictures = [];
      this.dialogFormObjetReadOnlyMode = this.readOnly;
      this.$emit('formCancel');
    },

    save() {
      log.t('# in save');
      this.dialogFormObjetHasErrors = false;
      /*
       Object.keys(this.formValidation).forEach((f) => {
       log.w(`in saveDialog iterating fields ${f} - this.formObjet[f] ${this.formValidation[f]}`);
       if (!this.$refs[f].validate(true)) {
       this.dialogFormObjetHasErrors = true;
       }
       this.$refs[f].validate(true);
       });
       */
      if (!this.dialogFormObjetHasErrors) {
        const tempItem = JSON.parse(JSON.stringify(this.editedItem));
        if (isNullOrUndefined(tempItem.properties.icon_src)) {
          const c = this.categories.find((x) => x.id === tempItem.properties.idcategorie);
          tempItem.properties.icon_src = c.icon;
        }
        this.$emit('formSave', tempItem);
      } else {
        log.e('# ERRORS in saveDialog');
      }
    },
    getCategoryStroke_width(idcategory) {
      const c = this.categories.find((x) => x.id === idcategory);
      if (isNullOrUndefined(c)) {
        return '1px';
      }
      return c.stroke_width; //    :path_geometry="c.path_geometry"
    },
    getCategoryStroke_color(idcategory) {
      const c = this.categories.find((x) => x.id === idcategory);
      if (isNullOrUndefined(c)) {
        return '#FFF';
      }
      return c.stroke_color; //    :path_geometry="c.path_geometry"
    },
    getCategoryPath_geometry(idcategory) {
      const c = this.categories.find((x) => x.id === idcategory);
      if (isNullOrUndefined(c)) {
        return 'm 360.1735,308.7905 24.599,138.208 -128.772,-65.255 -128.771,65.255 24.598,-138.208 -104.173,-97.884 143.973,-20.15 64.373,-125.755 64.373,125.755 143.972,20.15 z';
      }
      return c.path_geometry;
    },
    getCategoryName(idcategory) {
      const c = this.categories.find((x) => x.id === idcategory);
      if (isNullOrUndefined(c)) {
        return '# ? #';
      }
      return c.name;
    },
    categoryChanged() {
      log.t('# in categoryChanged', this.editedItem.properties.idcategorie);
      const c = this.categories.find((x) => x.id === this.editedItem.properties.idcategorie);
      const strLocation = this.editedItem.properties.title.split(', ')[0];
      // eslint-disable-next-line no-irregular-whitespace
      this.editedItem.properties.title = `${strLocation}, ${c.name}`;
      this.editedItem.properties.icon_src = c.icon;
    },
    buttonColor(idCat, currentId, currentName) {
      if (currentName.startsWith('CID-')) {
        if (idCat === currentId) {
          return '#80cbc4';
        }
        return '#009688';
      }
      if (currentName.startsWith('MAP-')) {
        if (idCat === currentId) {
          return '#ef9e7f';
        }
        return '#ce592b';
      }
      if (idCat === currentId) {
        return 'accent';
      }
      return 'primary';
    },
  }, // end of methods
};
</script>
